<script lang="ts" setup>
import type { AutoTradeTrigger } from '@/services/auto-trade-trigger-service/types'
import { computed } from 'vue';
import { i18n } from '@/i18n';

const { t } = i18n.global
const props = defineProps<{
  data: AutoTradeTrigger
  resetting?: boolean
  onReset?: () => void
}>()

const data = computed(() => props.data)

const isPreparing = computed(() => {
  return data.value.active && !data.value.is_prepared
})

const severity = computed(() => {
  if (props.resetting) return 'warn'
  if (!data.value.active) return 'error'
  if (isPreparing.value) return 'warn'
  if (data.value.position_opened) return 'warn'
  return 'success'
})

const clickable = computed(() => {
  return !props.resetting && !isPreparing.value && (data.value.is_preparation_failed || data.value.is_trading_failed)
})

const onClick = () => {
  if (!clickable.value) {
    return
  }
  props.onReset?.()
}
const label = computed(() => {
  if (props.resetting) return '...'
  if (isPreparing.value) return t('modal.autoTradeTrigger.preparing')
  if (!data.value.active) {
    if (data.value.is_preparation_failed || data.value.is_trading_failed) {
      return t('error')
    }
    return t('inactive')
  }
  if (data.value.position_opened) return t('inPosition')
  return t('active')
})

const tooltipText = computed(() => {
  if (isPreparing.value) {
    return t('modal.autoTradeTrigger.preparing')
  }
  if (!data.value.active) {
    if (data.value.is_preparation_failed) {
      return t('modal.autoTradeTrigger.preparationFailed')
    }
    if (data.value.is_trading_failed) {
      return t('modal.autoTradeTrigger.traidingFailed')
    }
    return t('modal.autoTradeTrigger.botInactive')
  } else {
    if (data.value.position_opened) return t('modal.autoTradeTrigger.posesOpen')
    return t('modal.autoTradeTrigger.botActive')
  }
})
</script>

<template>
  <span @click="onClick" :class="`pit ${severity}${clickable ? ' hover cursor-pointer' : ''}`"
    v-tooltip.bottom="tooltipText">
    {{ label }}
  </span>
</template>
